module.exports = __webpack_public_path__ + "assets/img/innadril.ec12be96.jpg";